import * as React from 'react';
import { Failure as ApiFailure, Request } from '../ApiClient';
import { ApiResult } from './ApiResult';
import { Context } from './Context';
import { useErrorHandler } from '../ErrorHandler';
import { Failure, Success } from '../Result';

export const useFetch = <R extends Request<Response>, Response, Error>(): ((
	request: R
) => Promise<ApiResult<Response, Error>>) => {
	const clients = React.useContext(Context);
	if (clients === null) {
		throw new Error();
	}

	const { onError } = useErrorHandler();

	return React.useCallback(async (request: R): Promise<ApiResult<Response, Error>> => {
		onError(null);

		try {
			const client = clients[request.api ?? 'api'];
			const response = await client.fetch<R, Response>(request);
			return new Success<Response, ApiFailure<Error>>(response);
		} catch (error) {
			if (!(error instanceof ApiFailure) || error.hasUnhandled(request.knownErrorCodes)) {
				onError(error);
				return new Failure(new ApiFailure(new Set()));
			}
			return new Failure(error);
		}
	}, []);
};
